import * as actions from './user.actions';

export const USER_FEATURE_KEY = 'user';

export enum LoadingState {
  Loading,
  Loaded,
  Error,
  None,
}

export interface UserState {
  invitationLink?: string;
  isLoadingInvitationLink?: LoadingState;
}

export const initialState: UserState = {
  isLoadingInvitationLink: LoadingState.None,
};

export function userReducer(
  state: UserState = initialState,
  action: actions.UserActions,
): UserState {
  switch (action.type) {
    case actions.UserActionTypes.REQUEST_INVITATION_LINK:
      return {
        ...state,
        invitationLink: undefined,
        isLoadingInvitationLink: LoadingState.Loading,
      };

    case actions.UserActionTypes.REQUEST_INVITATION_LINK_SUCCESS:
      return {
        ...state,
        invitationLink: action.payload,
        isLoadingInvitationLink: LoadingState.Loaded,
      };

    case actions.UserActionTypes.REQUEST_INVITATION_LINK_FAILURE:
      return {
        ...state,
        isLoadingInvitationLink: LoadingState.Error,
      };

    default:
      return state;
  }
}
